(function () {
  const FACETS_TOP_SELECTOR = ".facets__horizontal-top";
  const WRAPPER_SELECTOR = ".collection-wrapper, .search-wrapper";
  const HEIGHT_VARIABLE = "--facets-top-height";

  const updateHeight = (facetsTop) => {
    const wrapper = facetsTop.closest(WRAPPER_SELECTOR);
    if (!wrapper) return;

    wrapper.style.setProperty(HEIGHT_VARIABLE, `${facetsTop.offsetHeight}px`);
  };

  const updateAll = () => {
    document.querySelectorAll(FACETS_TOP_SELECTOR).forEach(updateHeight);
  };

  if (typeof ResizeObserver === "undefined") {
    window.addEventListener("resize", updateAll);
    document.addEventListener("shopify:section:load", updateAll);
    updateAll();
    return;
  }

  const resizeObserver = new ResizeObserver((entries) => {
    entries.forEach((entry) => updateHeight(entry.target));
  });

  const observeFacetsTop = () => {
    resizeObserver.disconnect();

    document.querySelectorAll(FACETS_TOP_SELECTOR).forEach((facetsTop) => {
      updateHeight(facetsTop);
      resizeObserver.observe(facetsTop);
    });
  };

  document.addEventListener("shopify:section:load", observeFacetsTop);
  document.addEventListener("shopify:section:unload", observeFacetsTop);

  observeFacetsTop();
})();
